import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const GameMenuCard = ({ to, icon: Icon, title, subtitle, accent = "blue", testId, delay = 0 }) => {
  const isAcid = accent === "acid";
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={to}
        data-testid={testId}
        className={`group light-sweep clip-corner relative flex h-full flex-col justify-between gap-8 border border-white/10 bg-[#0F1217] p-6 sm:p-8 transition-colors duration-200 hover:border-white/25 ${
          isAcid ? "hover:neon-edge-acid" : "hover:neon-edge"
        }`}
      >
        {/* top row */}
        <div className="flex items-start justify-between">
          <div
            className={`clip-corner-sm flex h-12 w-12 items-center justify-center ${
              isAcid ? "bg-[#B7FF2A]/10 text-[#B7FF2A]" : "bg-[#1EA7FF]/10 text-[#1EA7FF]"
            }`}
          >
            <Icon className="h-6 w-6" strokeWidth={2.2} />
          </div>
          <ArrowUpRight
            className={`h-5 w-5 text-white/30 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 ${
              isAcid ? "group-hover:text-[#B7FF2A]" : "group-hover:text-[#1EA7FF]"
            }`}
          />
        </div>

        <div>
          <div className="font-display text-3xl sm:text-4xl uppercase tracking-[0.06em] leading-none">
            <span className="rgb-split" data-text={title}>
              {title}
            </span>
          </div>
          <p className="mt-2 text-sm text-white/55 leading-relaxed">{subtitle}</p>
        </div>

        {/* bottom accent rail */}
        <div className="absolute bottom-0 left-0 right-0 h-[3px] overflow-hidden">
          <div
            className={`h-full w-0 transition-[width] duration-500 ease-out group-hover:w-full ${
              isAcid ? "bg-[#B7FF2A]" : "bg-[#1EA7FF]"
            }`}
          />
        </div>
      </Link>
    </motion.div>
  );
};
